import React from 'react'
import styles from './OrderForm.module.css'
import Banner from '../Banner'
import { getFormattedPrice } from '../../helpers/formatPrice'
import RadioButton from '../RadioButton'
import { OrderUpdateError } from '../../types/Order'

interface Props {
  originalTotalPrice: number
  error: OrderUpdateError
  onPaymentMethodChange: (paymentMethod: string) => void
  noBottomSpacing?: boolean
}
function PaymentMethod ({ originalTotalPrice, error, onPaymentMethodChange, noBottomSpacing = false }: Props) {
  const [selectedMethod, setSelectedMethod] = React.useState('Payex')

  const paymentMethods = [
    { id: 'Payex', label: 'Kortbetalning' },
    { id: 'InStore', label: 'Betala i butik' }
  ]

  const handleChange = (id: string) => {
    setSelectedMethod(id)
    onPaymentMethodChange(id)
  }

  return (
    <>
      <div className={styles.bannerContainerAlt}>
        <Banner
          theme={error.isError ? 'warning' : 'info'}>
          <span className={styles.bannerText}>
            {error.isError ? (
              <span className={styles.bannerTextBold}>
                {error.errorText}
              </span>
            ) : selectedMethod === 'InStore' ? (
              <span className={styles.bannerTextBold}>Reserverat belopp kommer att släppas direkt.</span>
            ) : (
              <>
                <span className={styles.bannerTextBold}>Kortbetalning:</span> Det går inte att genomföra ändringar som ökar det reserverade beloppet på {getFormattedPrice(originalTotalPrice)}. Ändra betalsätt till &quot;betala i butik&quot; för att öka beloppet.
              </>
            )}
          </span>
        </Banner>
      </div>
      <div className={`${styles.paymentSection} ${noBottomSpacing ? styles.noBottomSpacing : ''}`}>
        <h4 className={styles.headingWithPadding}>Ändra betalsätt</h4>
        <div className={styles.paymentContent}> 
          <span className={styles.fieldLabel}>Betalsätt</span>
          <div className={styles.radioGroup}>
            {paymentMethods.map((method) => (
              <RadioButton
                key={method.id}
                id={method.id}
                checked={method.id === selectedMethod}
                onChange={() => handleChange(method.id)}
              >
                {method.label}
              </RadioButton>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default PaymentMethod
